// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2h7m0","obliqueLineWrap":"membershipbadge_obliqueLineWrap__nnCzi","obliqueLine":"membershipbadge_obliqueLine__QOmNl"};